import React from 'react';

import { GridValidRowModel } from '@mui/x-data-grid';

import { VatixError } from 'components/Error/types';

import Grid, { defaultFormatters, defaultOperators, defaultRenderers } from 'components/Grid';
import { ColumnDefinition, FilterType } from 'components/Grid/types';

import { EmptyValue } from 'components/SharedFormComponents/CustomFieldDisplayValue/styles';

import { ListRendererType } from 'components/Grid/renderers/GridListRenderer/types';
import { listRenderer } from 'components/Grid/renderers/GridListRenderer';
import GridChipRenderer from 'components/Grid/renderers/GridChipRenderer';

import Search from 'components/Grid/operators/Search';
import API from 'utils/api/api';

import { formatMoment } from 'utils/formatters/timezone';
import { DATETIME_COLUMN_MIN_WIDTH, DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR } from 'core/constants';

import { StyledCreated, Container } from '../UsageReportTable/styles';

const basicColumns = [
  {
    field: 'phoneNumber',
    headerName: 'Phone',
    nativeFilter: true,
    sortable: false,
  },
  {
    field: 'tags',
    headerName: 'User tags',
    filterOperators: Search(API.devices.searchDeviceTags, API.devices.deviceTagsDetails, 'name'),
    renderCell: listRenderer(GridChipRenderer as unknown as ListRendererType, 3),
    nativeFilter: 'user_tags',
    valueGetter: (_value: unknown, row: GridValidRowModel) => (row.user ? row.user.tags : []),
  },
  {
    field: 'user',
    headerName: 'User',
    filterOperators: defaultOperators.user(),
    renderCell: defaultRenderers.user ? defaultRenderers.user : undefined,
    valueFormatter: defaultFormatters.user,
    valueGetter: (value: unknown) => ({ value }),
    nativeFilter: 'users',
  },
  {
    field: 'lastPoll',
    filterOperators: defaultOperators.date_time(),
    headerName: 'Last online',
    minWidth: DATETIME_COLUMN_MIN_WIDTH,
    renderCell: ({ value }: { value: string }) =>
      value ? (
        <StyledCreated data-testid="usage-last-online">
          {formatMoment(value, DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR)}
        </StyledCreated>
      ) : (
        <EmptyValue>-</EmptyValue>
      ),
    nativeFilter: true,
    valueFormatter: defaultFormatters.date_time,
  },
] as unknown as ColumnDefinition[];

const DeviceList: React.FunctionComponent<{
  onError: (error: VatixError) => void;
  filters: FilterType[];
  onRefreshCallback: (callback: () => void) => void;
}> = ({ onError, filters, onRefreshCallback }): React.ReactElement => (
  <Container>
    <Grid
      temporaryFilters={filters}
      onRefreshCallback={onRefreshCallback}
      basicColumns={basicColumns}
      entity="device"
      onError={onError}
      dataURL="/api/reports/usage/table/?type=mobile"
      disableColumnSelector
    />
  </Container>
);

export default DeviceList;
